var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHibob = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#e52c51",
    width: "100%",
    height: "100%"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 181.049 202.477 L 181.049 103.994 C 181.049 89.872 169.69 78.417 155.705 78.417 C 141.706 78.417 130.349 89.872 130.349 103.994 L 130.349 300.916 C 130.426 367.515 184.075 421.584 250.012 421.584 C 315.969 421.584 369.651 367.447 369.651 300.916 C 369.651 234.373 315.969 180.259 250.012 180.259 C 224.325 180.259 200.559 188.523 181.049 202.477 Z M 250.012 370.464 C 211.983 370.464 181.049 339.276 181.049 300.916 C 181.049 262.567 211.983 231.378 250.012 231.378 C 288.028 231.378 318.963 262.567 318.963 300.916 C 318.963 339.276 288.028 370.464 250.012 370.464"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHibob);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hibob.e35c3f3c6e54d428ed7c247eb7f9eecc.svg";